import { render, staticRenderFns } from "./ShopBundleRecord.vue?vue&type=template&id=4ab4c72a"
import script from "./ShopBundleRecord.vue?vue&type=script&lang=js"
export * from "./ShopBundleRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports